import { HeaderTypeTokens, ColorTokens, } from '@voltmoney/schema';
export const headerTypeTokenMap = {
    [HeaderTypeTokens.header]: {
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Black,
    },
    [HeaderTypeTokens.verification]: {
        labelColor: ColorTokens.Grey_Night,
        bgColor: ColorTokens.White,
    },
    [HeaderTypeTokens.DEFAULT]: {
        labelColor: ColorTokens.Grey_Night,
        bgColor: ColorTokens.White,
    },
    [HeaderTypeTokens.HEADERCTA]: {
        labelColor: ColorTokens.Grey_Night,
        bgColor: ColorTokens.White,
    },
    [HeaderTypeTokens.PARTNER]: {
        labelColor: ColorTokens.White,
        bgColor: ColorTokens.Black,
    },
};
